// extracted by mini-css-extract-plugin
module.exports = {"InputArea":"ImageRegister_InputArea__1dyAh","BtnArea":"ImageRegister_BtnArea__1TAyL"};